import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer'
import { useTranslation } from "react-i18next";

import { Button, } from "@mui/material";

import { persistor } from "index";
import { LOGOUT } from "store/reducers/auth";
import { deleteUser } from "store/reducers/userSlice";
  
const LogoutPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    
    // const expireOut = process.env.REACT_APP_DEFAULT_LOGIN_EXPIRE_TIME * 1000;
    // const [remaining, setRemaining] = useState(expireOut)
    
    const logout = async () => {
        dispatch(LOGOUT());
        dispatch(deleteUser());
    }

    //초기화 하는 함수
    const purge = async () => {
        await persistor.purge();
        navigate('/auth/login');
    }
    
    const onIdle = async() => {
        console.log('Idle');
        await logout()
        setTimeout(async() => await purge(), 200)
    }

    const onActive = () => {
        console.log('Active');
    }

    // const { getRemainingTime } = useIdleTimer({
    //     onIdle,
    //     onActive,
    //     // onPrompt,
    //     //timeout: process.env.REACT_APP_DEFAULT_LOGIN_EXPIRE_TIME * 1000,
    //     timeout: expireOut,
    //     // promptBeforeIdle,
    //     throttle: 500
    // })

    return (
        <>
        <Button variant="contained" onClick={async () => {
            await logout()
            setTimeout(async() => await purge(), 200)
        }}>{t('header.logout')}
        </Button>

      </>
    )
}

export default LogoutPage;